import React from "react";

const departureDeclarationRoutes = [
    {
        path: "/applications/departureDeclaration/list",
        component: React.lazy(() =>
            import("./DepartureDeclarationList")
        ),
    },

    {
        path: "/applications/departureDeclaration/:viewType/:appId",
        component: React.lazy(() =>
            import("./DepartureDeclarationDetails")
        ),
    },
];

export default departureDeclarationRoutes;